<template>
  <DataRemovalScreen
    :machine-send="resolutionFlowStateMachine.send"
    @submit="goToPicturesPage"
  />
</template>

<script lang="ts" setup>
import { navigateTo, useRouteLocationWithLocale } from '#imports'
import { inject } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import DataRemovalScreen from '~/scopes/customer-care/resolution/components/ResolutionFlowScreens/screens/Return/DataRemovalScreen/DataRemovalScreen.vue'
import type { ProvideResolutionFlowMachine } from '~/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'
import { ResolutionFlowStateMachineKey } from '~/scopes/customer-care/resolution/symbols'
import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'

const resolutionFlowStateMachine = inject(
  ResolutionFlowStateMachineKey,
) as ProvideResolutionFlowMachine

const resolveLocalizedRoute = useRouteLocationWithLocale()
const goToPicturesPage = async () => {
  await navigateTo(
    resolveLocalizedRoute({
      name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.PICTURES,
    }) as RouteLocationRaw,
  )
}
resolutionFlowStateMachine?.send('GO_TO_DATA_REMOVAL')
</script>
